import { HttpResponse } from '@angular/common/http';
import { Course, CourseDto } from '@app/store/shared/models';

export class PaginatedDto {
    readonly payload: Course[];
    readonly total: number;

    constructor(response: HttpResponse<CourseDto[]>) {
        this.payload = (response.body ?? []).map((dto) => new Course(dto));
        this.total = parseInt(response.headers.get('X-Total-Count') ?? '0', 10);
    }
}
